/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUserReferralsResponseItem } from './search-user-referrals-response-item';


export interface SearchUserReferralsResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchUserReferralsResponseItem> | null;
}

